export const APPROVAL_FLOWS_PERMISSION = "approval_policy:read"

export const CREATE_FLOWS_PERMISSION = "approval_policy:create"

export const UPDATE_FLOWS_PERMISSION = "approval_policy:update"

export const DELETE_FLOWS_PERMISSION = "approval_policy:delete"
